import axios from 'axios'
import qs from 'qs'

export const leapsIntentionService = ({
  getLeapsIntentionList (token) {
    return axios.get('/api/leaps/intention', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsIntention (token, leapsIntentionObj) {
    var stringifiedObj = qs.stringify(leapsIntentionObj)
    return axios.post('/api/leaps/intention', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsIntention (token, leapsIntentionObj) {
    var stringifiedObj = qs.stringify(leapsIntentionObj)
    return axios.put('/api/leaps/intention', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsIntention (token, intentionId) {
    return axios.delete('/api/leaps/intention?intentionId=' + intentionId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-intention-service.js